import React from 'react';

import {DataLoader} from 'src/js/common/types';

export function renderNestedComponents(
  renderMap: DataLoader[],
  children,
  inputComponent?: React.ElementType
) {
  const Component = renderMap.reduce(
    (ComponentSoFar, props) => {
      const {component, ...restProps} = props;
      const Outer = inputComponent ?? component;
      const NewComponent = () => (
        <Outer {...restProps}>
          <ComponentSoFar />
        </Outer>
      );
      return NewComponent;
    },
    () => children
  );
  return <Component />;
}
